@if (traceabilityAttributes && traceabilityAttributes.length > 0) {
<div [ngClass]="{ 'margin-if-recyclable': hasRecyclability }">
    <h-svg-icon class="icon" [name]="'tracability'"></h-svg-icon>
    <h3 i18n="@@hermes.environment.category-tracability" class="label">Tracability</h3>
    <ul class="paragraph-small">
        @for (traceability of traceabilityTexts; track traceability) {
        <li>{{ traceability }}</li>
        }
    </ul>
</div>
}
